var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 2,
    fill: "white",
    stroke: "#004685",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7235 10.7199C15.901 10.534 16 10.2869 16 10.0299C16 9.773 15.901 9.52592 15.7235 9.33994C15.5359 9.15369 15.2822 9.04915 15.0177 9.04915C14.7532 9.04915 14.4995 9.15369 14.3119 9.33994L11.0081 12.6799V7.33996V4.99999C11.0081 4.73478 10.9026 4.48042 10.7149 4.29289C10.5271 4.10536 10.2725 4 10.0069 4C9.74141 4 9.48677 4.10536 9.29902 4.29289C9.11126 4.48042 9.00579 4.73478 9.00579 4.99999V12.6099L5.71201 9.35994C5.52443 9.1737 5.27069 9.06915 5.0062 9.06915C4.74171 9.06915 4.48797 9.1737 4.30039 9.35994C4.12561 9.52964 4.01882 9.7572 4.00004 9.99994C3.99882 10.1248 4.02303 10.2485 4.07123 10.3637C4.11942 10.4789 4.19058 10.5831 4.28037 10.6699L9.28611 15.6699C9.37743 15.771 9.48847 15.8524 9.61242 15.9092C9.73637 15.9659 9.87062 15.9968 10.0069 15.9999C10.2716 16.0041 10.5272 15.9034 10.7177 15.7199L15.7235 10.7199Z",
    fill: "#004685"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDownload);
export default __webpack_public_path__ + "static/media/picto_download.91b4c452c8a11c0c843ee0988d241211.svg";
export { ForwardRef as ReactComponent };